import { Address } from "./Address";
import Image from "./Image";

export default class Teachr {
  readonly "@id"?: string;
  readonly "@type"?: string;
  readonly "@context"?: string;

  address?: Address | any;
  birthday: Date | string;
  whereStudies: string;
  yearInStudies: number;
  description: string;
  siren?: number;
  iban?: string;
  bic?: string;
  subjectToTeach?: string[] | any;
  otherSubjects?: string;
  otherSueperiorSubjects?: string;
  NNI?: string;
  secondFirstName?: string;
  bornPlace?: string;
  proofIsAE?: any;
  marriedName?: string;
  isBornFrance?: boolean;
  RCS?: string;
  firebaseAuthToken: string;
  firstName: string;
  lastName: string;
  phone: string | null;
  mail: string | null;
  profilePicture?: any;
  sex: string;
  firebaseMessagingToken: string;
  geoPoint?: string;
  geoDistance?: number;
  acceptMarketingEmail?: boolean;
  isValidated?: boolean;
  isAE?: boolean;
  // Calculé par le backend (Teachr::isAccountActive) : validé, AE, SAP signé, mandat déposé
  accountActive?: boolean;
  businessType?: string;
  signSap?: boolean;
  isShowInfos?: boolean;
  proofSignSap?: any;
  proofIdentity?: any;
  proofIdentity2?: any;
  proofMandat?: any;
  recommandedBy?: string;
  codeNature?: string;
  invitationCode?: string;
  defaultFees?: string;
  isFirstCourse?: boolean;
  isOldFacturation?: boolean;
  isMandatSepa?: boolean;
  isTdae?: boolean;
  tvaNumber?: string;
  tauxTva?: string;
  sponsorship?: string | null;
  statusTdae?: string;
  brand?: string;
  procuration?: string;
  level?: string;
  numberOfStudents?: number;

  scoop?: string | null;
  molliePaymentId?: string | null;
  mollieCheckoutUrl?: string | null;

  // isTdae?: boolean;
  // statusTdae?: string;

  readonly id?: number;

  readonly lastModificationDatetime?: Date;

  readonly creationDatetime?: Date;

  constructor(
    firebaseAuthToken: string,
    firstName: string,
    lastName: string,
    mail: string | null,
    phone: string | null,
    firebaseMessagingToken: string,
    sex: string,
    whereStudies: string,
    yearInStudies: number,
    description: string,
    birthday: Date | string,
  ) {
    this.firebaseAuthToken = firebaseAuthToken;
    this.firstName = firstName;
    this.lastName = lastName;
    this.phone = phone;
    this.mail = mail;
    this.firebaseMessagingToken = firebaseMessagingToken;
    this.whereStudies = whereStudies;
    this.yearInStudies = yearInStudies;
    this.description = description;
    this.sex = sex;
    this.birthday = birthday;
  }
}
